import React from "react";
import MtiButton from "../../Buttons/MtiButton";
import "../../../WarningView.css";

type Props = {
  title: string;
  message: string;
  subMessage: string;
};

export default function WarningModalView({
  title,
  message,
  subMessage,
}: Props) {
  return (
    <div className="app-warning-wait-container">
      <span className="warning-title-wait">{title}</span>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gridArea: "animation",
          marginBottom: 40,
          marginTop: 41,
        }}
      >
        <svg
          width="71"
          height="71"
          viewBox="0 0 71 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M70.0832 35.5001C70.0832 54.5999 54.5997 70.0834 35.4998 70.0834C16.4 70.0834 0.916504 54.5999 0.916504 35.5001C0.916504 16.4002 16.4 0.916748 35.4998 0.916748C54.5997 0.916748 70.0832 16.4002 70.0832 35.5001ZM21.6665 56.2501L35.4998 42.4167L49.3332 56.2501L56.2498 49.3334L42.4165 35.5001L56.2498 21.6667L49.3332 14.7501L35.4998 28.5834L21.6665 14.7501L14.7498 21.6667L28.5832 35.5001L14.7498 49.3334L21.6665 56.2501Z"
            fill="#DB0000"
          />
        </svg>
      </div>
      <span className="warning-message-wait centered">{message}</span>
      <span className="warning-sub-message-wait centered">{subMessage}</span>
    </div>
  );
}
